import React from 'react';
import PropTypes from 'prop-types';
import styles from '@Components/Events/Tile/TileEvent.module.sass';

const TilesEventRowContainer = ({children}) => {
	return (
		<div className={ styles["tile-event-row__container"] }>
			{children}
		</div>
	);
};

TilesEventRowContainer.propTypes = {
	children: PropTypes.array,
};

export default TilesEventRowContainer;